import { useTheme } from '@/src/contexts/ThemeContext';

/**
 * Shared colour tokens for the authenticated app (post-login screens).
 * Every screen should pull from here rather than hardcoding its own
 * dark/light hex values, so the whole app stays visually consistent
 * and a single palette tweak propagates everywhere.
 *
 * (SignIn.tsx has its own local `useSignInColors` predating this —
 * worth folding into this hook later so there's only one source of truth.)
 */
export function useAppColors() {
  const { isDark } = useTheme();

  return {
    isDark,

    // Page background
    bg: isDark ? '#0F0F0D' : '#FAF8F9',

    // Card / panel surfaces
    bgElevated: isDark ? '#161614' : '#FFFFFF',
    bgElevatedAlt: isDark ? '#111410' : '#F4F0EA', // secondary surface / featured-card tint

    // Text
    text: isDark ? '#F0EEE8' : '#1D1D18',
    textDim: isDark ? 'rgba(255,255,255,0.5)' : '#6E6E64',
    textFaint: isDark ? 'rgba(255,255,255,0.25)' : '#A6A69A',

    // Borders
    border: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.08)',
    borderStrong: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.12)',

    // Brand green — accent
    accent: '#2E5A32',
    accentSoft: isDark ? '#8AE08A' : '#2E5A32',
    accentBg: isDark ? 'rgba(100,180,100,0.24)' : 'rgba(74,154,74,0.18)',
    accentBorder: isDark ? 'rgba(100,180,100,0.32)' : 'rgba(74,154,74,0.35)',

    // Neutral icon chip (non-featured items)
    iconBg: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.045)',
    iconColor: isDark ? 'rgba(255,255,255,0.4)' : '#6E6E64',

    danger: isDark ? '#F87171' : '#DC2626',
    gold: '#E8A020',
  };
}